import { combineReducers } from '@reduxjs/toolkit';
import { appSlice, signout } from './appSlice';
import { abbiWayApi } from '../services/abbiWayApi';
const appReducer = combineReducers({
    app: appSlice.reducer,
    [abbiWayApi.reducerPath]: abbiWayApi.reducer,
});
const rootReducer = (state, action) => {
    if (signout.match(action)) {
        // blow away anything cached by RTK Query on signout
        // https://github.com/rtk-incubator/rtk-query/issues/162#issuecomment-772813328
        // (without mutating the previous state). signoutResetMiddleware then
        // dispatches resetApiState so RTK Query's middleware state resets too.
        return appReducer(state ? { ...state, [abbiWayApi.reducerPath]: undefined } : state, action);
    }
    return appReducer(state, action);
};
export default rootReducer;
